import { render, staticRenderFns } from "./photo-guidelines.vue?vue&type=template&id=f049bae8&scoped=true&lang=pug&"
import script from "./photo-guidelines.vue?vue&type=script&lang=js&"
export * from "./photo-guidelines.vue?vue&type=script&lang=js&"
import style0 from "./photo-guidelines.vue?vue&type=style&index=0&id=f049bae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f049bae8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/src/SelfService.App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f049bae8')) {
      api.createRecord('f049bae8', component.options)
    } else {
      api.reload('f049bae8', component.options)
    }
    module.hot.accept("./photo-guidelines.vue?vue&type=template&id=f049bae8&scoped=true&lang=pug&", function () {
      api.rerender('f049bae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/photos/guidelines/photo-guidelines.vue"
export default component.exports